import {
	BackgroundRemoverLogo,
	BellIcon,
	BulbIcon,
	CircularTickIcon,
	DarkModeIcon,
	NotificationAlertIcon,
	NotificationCircularStopSignIcon,
} from '../../icons'

export const BellNotifications: React.FC = () => {
	return (
		<div className='bell-notifications'>
			<section className='heading'>
				<h3>Notification</h3>
				<BellIcon />
			</section>
			<section className='notifications-area'>
				<section className='noti'>
					<CircularTickIcon />
					<section className='text-content'>
						<p>
							<b>Your project</b> ADYOUNEED Christmas Project{' '}
							<b>is generated and ready to be reviewed.</b>
						</p>
						<p>15.01.2021</p>
					</section>
				</section>
				<section className='noti'>
					<NotificationAlertIcon />
					<section className='text-content'>
						<p>
							<b>Your payment method</b> is rejected, click here to{' '}
							<b>keep using AdCreative.AI</b>
						</p>
						<p>15.01.2021</p>
					</section>
				</section>
				<section className='noti'>
					<NotificationCircularStopSignIcon />
					<section className='text-content'>
						<p>
							<b>Your project</b> ADYOUNEED Christmas Project{' '}
							<b>is generated and ready to be reviewed.</b>
							<b>Your download</b> limit is about to finish! Upgrade your
							package or contact us<b>to continue generating creatives.</b>
						</p>
						<p>15.01.2021</p>
					</section>
				</section>
				<section className='noti'>
					<CircularTickIcon />
					<section className='text-content'>
						<p>
							<b>Your project</b> ADYOUNEED Christmas Project{' '}
							<b>is generated and ready to be reviewed.</b>
						</p>
						<p>15.01.2021</p>
					</section>
				</section>
			</section>
		</div>
	)
}
